import React, { memo } from 'react';
import { View, FlatList } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';

export const ProfileSettingItems = memo(
  ({ title, description, data, renderItem, children, style }) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.container, style]}>
        <Text style={styles.titleText}>{title}</Text>
        <Space size={8} />
        <Text style={styles.descriptionText}>{description}</Text>
        <Space />
        <View style={styles.contentContainer}>
          {children ? (
            children
          ) : (
            <FlatList
              {...{ renderItem, data }}
              horizontal
              ItemSeparatorComponent={() => <Space size={25} />}
              showsHorizontalScrollIndicator={false}
            />
          )}
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    marginVertical: 16,
  },
  contentContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleText: {
    color: colors.gray23,
    fontSize: 16,
    lineHeight: 26,
    fontWeight: '400',
  },
  descriptionText: {
    color: colors.gray21,
    fontSize: 12,
    lineHeight: 18,
    fontWeight: '400',
  },
}));
